"use strict"

let ComboBox;

export class Listener {
    
    static init(cb) {
        ComboBox=cb;
        window.addEventListener('focus', Listener.click, true);
        window.addEventListener('click', Listener.click, true);
        window.addEventListener('mousedown', Listener.mousedown, true);
        window.addEventListener('touchstart', Listener.mousedown, true);
        window.addEventListener('mouseup', Listener.mouseup, true);
        window.addEventListener('touchend', Listener.mouseup, true);
        window.addEventListener('blur', ()=>{Listener.blur()}, false);
        window.addEventListener('touchstart', Listener.mouseOver, true);
        window.addEventListener('mousedown', Listener.mouseOver, true);
        window.addEventListener('mouseover', Listener.mouseOver, true);
        window.addEventListener('keydown', Listener.keyDown, true);
        window.addEventListener('keyup', Listener.keyUp, true);
        window.addEventListener('paste', Listener.paste, true);
        
        window.addEventListener('scroll', Listener.scroll, true);
        
        Listener.blur();
        
    }
    
    
    static scroll(event) {
        if (event&&event.target&&(event.target==ComboBox.inner)) {
            Listener.mouseTarget=null;
        } else {
            ComboBox.Renderer.position(event);
        }
    }
    
    static dispatch(input=ComboBox.input, message=null) {
   
        if (input instanceof HTMLElement) {
            setTimeout(()=>{
                console.log(message||('combo'+(ComboBox.input.multiple?' multi ':' ')+'change'));
                try {if (window.$) { $(input).trigger('change')} } catch(e) {console.error(e);}
                try {input.dispatchEvent(new CustomEvent('change', {bubbles:true}))} catch(e) {console.error(e);}
            }, 25); // na change event např v požadavcích je posluchač, který klikne jinam ještě než doběhne combo a nadělá paseku; dispatch nutno provést zpožděně.
        }
    }

    static mousedown(event) {
        switch (event.type) {
            case 'mousedown':
                if (event.button) return;
        }
        if ((event.target instanceof HTMLElement)&&event.target.matches('.new-combobox-options, .new-combobox-options *')) {
            Listener.mouseTarget=event.target;
            event.preventDefault();
            return false;
        } else {
            Listener.mouseTarget=null;
        }
    }

    static mouseup(event) {
        if ((event.target instanceof HTMLElement)&&event.target==Listener.mouseTarget) {
            if (event.target.matches('.combobox-option:not(.disabled), .combobox-option:not(.disabled) *')) {
                let target=event.target;
                let t=ComboBox.target;
                while (target.parentNode&&!target.matches('.combobox-option:not(.disabled)')) {
                    target=target.parentNode;
                }
                Listener.blur(target);
                t.blur();
                t.focus();
                Listener.click({type:'focus', target:t});
            }
            event.preventDefault();
            return false;
        };
        
    }
    
    static blur(option) {

        let dontHide=false;

        if (!option instanceof HTMLElement) {option=null;}

        if (ComboBox.target) {

            if (ComboBox.input&&ComboBox.input.matches('select')&&ComboBox.input.multiple) {
                // v tuto chvíli asi nic
            } else {
                if (option) {ComboBox.target.value=option.dataset.short||option.innerText;}
                else {ComboBox.target.value=ComboBox.oldDisplay;}
            }
//            ComboBox.target.selectionStart=0;
//            ComboBox.target.selectionEnd=0;
        }

        if (ComboBox.input) {

            let multiple=ComboBox.input.matches('select')&&ComboBox.input.multiple;

            if (option) {
                if (ComboBox.input.matches('select')) { 
                    if ((!multiple)&&(ComboBox.ajax_url)) {ComboBox.input.innerHTML='';}
                    let canAdd=true;
                    let canSet=false;
                    if (multiple) {
                        dontHide=ComboBox.input.matches('.dont-hide');
                        let options=ComboBox.input.querySelectorAll('option');
                        for (let i=0, l=options.length; i<l; i++) {
                            if (options[i].value==option.dataset.value) {
                                if (option.querySelector('.option-checked')) {
                                    if (ComboBox.ajax_url) {
                                        let o=options[i];
                                        setTimeout(()=>{o.parentNode.removeChild(o);}, 25);
                                    } 
                                    options[i].selected=false;
                                    options[i].removeAttribute('selected');
                                    canAdd=false;
                                    canSet=true;
                                } else {
                                    if (ComboBox.input.matches('.user-sequence')) {
                                        ComboBox.input.appendChild(options[i]);
                                    }
                                    canAdd=false;
                                    canSet=true;
                                    options[i].selected=true;
                                    options[i].setAttribute('selected', 'selected');
                                }
                            }
                        }
                        if (ComboBox.multi&&ComboBox.input.matches('.user-sequence')) {
                            let multi=ComboBox.multi.querySelectorAll('.multioption');
                            for (let i=0, l=multi.length; i<l; i++) {
                                if (multi[i].dataset.value==option.dataset.value) {
                                    canSet=true;
                                    multi[i].classList.remove('animate-in');
                                    if (!ComboBox.multi.querySelector('.multioption.multi-show-more')) {
                                        multi[i].classList.add('animate-out');
                                        let e=multi[i];
                                        setTimeout(()=>{if (e&&e.parentNode) {e.parentNode.removeChild(e)}}, 750);
                                    } else {
                                        multi[i].parentNode.removeChild(multi[i]);
                                    }
                                }
                            }
                        }
                    } else {
                        let options=ComboBox.input.querySelectorAll('option');
                        for (let i=0, l=options.length; i<l; i++) {
                            options[i].selected=(options[i].value==option.dataset.value);
                            options[i][(options[i].value==option.dataset.value?'set':'remove')+'Attribute']('selected', 'selected');
                        }
                        canSet=true;
                    }

                    if (canAdd&&((ComboBox.ajax_url)||(multiple))) {
                        let o=document.createElement('option');
                        o.value=option.dataset.value;
                        o.dataset.short=option.dataset.short||"";//||option.innerText;
                        o.innerText=option.dataset.label||option.innerHTML;
                        ComboBox.input.appendChild(o);
                        o.selected=true;
                        o.setAttribute('selected', 'selected');
                    }

                    if (multiple&&ComboBox.multi) {
                      /*  if (ComboBox.input.matches('.user-sequence')) {
                            if (option.querySelector('.option-checked')) {
                            } else {

                                let multi=ComboBox.Renderer.addMultiOption(ComboBox.multi, ComboBox.input, option.dataset.value, option.dataset.short||option.innerText);
                                ComboBox.Renderer.multiOptionsOverflow(ComboBox.multi);
                                if (!ComboBox.multi.querySelector('.multioption.multi-show-more')) {
                                    multi.classList.add('animate-in');
                                    setTimeout(()=>{multi.classList.remove('animate-in');}, 750);
                                }
                                
                            }
                        } else */{
                            ComboBox.multi.innerHTML='';
                            for (let i=0, l=ComboBox.input.options.length; i<l; i++) {
                                if (ComboBox.input.options[i].selected) {
                                    let multi=ComboBox.Renderer.addMultiOption(ComboBox.multi, ComboBox.input, ComboBox.input.options[i].value, ComboBox.input.options[i].dataset.short||ComboBox.input.options[i].innerText);
                                    if (multi.dataset.value==option.dataset.value) {
                                        multi.classList.add('to-animate-in');
                                        setTimeout(()=>{multi.classList.remove('to-animate-in');}, 750);
                                    }
                                } else {
                                    if ((option.querySelector('.option-checked')) && (ComboBox.input.options[i].value==option.dataset.value)) {
                                        let multi=ComboBox.Renderer.addMultiOption(ComboBox.multi, ComboBox.input, ComboBox.input.options[i].value, ComboBox.input.options[i].dataset.short||ComboBox.input.options[i].innerText);
                                        multi.classList.add('to-animate-out');
                                        setTimeout(()=>{if (multi.parentNode) {multi.parentNode.removeChild(multi);}}, 750);                                        
                                    }
                                }
                            }                 
                            ComboBox.Renderer.multiOptionsOverflow(ComboBox.multi);
                            if (ComboBox.multi.querySelector('.multioption.multi-show-more')) {
                                let e;
                                while (e=ComboBox.multi.querySelector('.to-animate-in')) {
                                    e.classList.remove('to-animate-in');
                                }
                                while (e=ComboBox.multi.querySelector('.to-animate-out')) {
                                    e.parentNode.removeChild(e);
                                }
                            } else {
                                let e;
                                while (e=ComboBox.multi.querySelector('.to-animate-in')) {
                                    e.classList.remove('to-animate-in'); e.classList.add('animate-in');
                                    let ee=e;
                                    setTimeout(()=>{ee.classList.remove('animate-in');}, 500);
                                }
                                while (e=ComboBox.multi.querySelector('.to-animate-out')) {
                                    e.classList.remove('to-animate-out'); e.classList.add('animate-out');
                                    let ee=e;
                                    setTimeout(()=>{if (ee.parentNode) {ee.parentNode.removeChild(ee);}}, 500);
                                }
                            }

                        }
                    }
                    //if (ComboBox.target) {ComboBox.target.value='';}
                    if ((canSet||ComboBox.ajax_url)&&!(multiple)) {
                        ComboBox.input.value=option.dataset.value;
                    }

                    if ((ComboBox.value !== (ComboBox.input.value||''))||(multiple)) {
                        Listener.dispatch(ComboBox.input);
                    }

                    if (canSet||ComboBox.ajax_url) {
                        ComboBox.value=option.dataset.value;
                    }

                    
                } else {
                    ComboBox.input.value=option.dataset.value;
                    ComboBox.input.dataset.label=option.dataset.short||option.innerText;
                    if (ComboBox.value !== ComboBox.input.value||'') {
                        Listener.dispatch(ComboBox.input);
                    }
                }
            }
            if (ComboBox.combo) {
                ComboBox.combo.classList[ComboBox.input.value&&((ComboBox.target&&ComboBox.target.value)||multiple)?'add':'remove']('combobox-has-value');
            }

        }

        if (ComboBox.combo) {
            ComboBox.combo.classList.remove('loading');
        }

        if (dontHide) {

            ComboBox.Renderer.animatePosition();
            ComboBox.Renderer.show();
            
        } else {

            ComboBox.Renderer.hide();

            if (ComboBox.input&&ComboBox.input.matches('select')&&ComboBox.input.multiple) {
                ComboBox.target.value='';
            }

            ComboBox.combo=null;        
            ComboBox.target=null;
            ComboBox.multi=null;
            ComboBox.input=null;
            ComboBox.options=[];
            ComboBox.originalOptions=[];
            ComboBox.value='';
            ComboBox.display='';
            ComboBox.oldDisplay='';
            ComboBox.keyPressed=false;
            ComboBox.ajax_url=null;
            ComboBox.ajax_param=null;
            ComboBox.ajax_pending=null;
            clearTimeout(ComboBox.timeout); //jinak se stalo, že při přepnutí na novej kombáč se začal hledat výraz z předchozího
            ComboBox.request++; // jinak se stalo, že se výsledek ajaxu nakreslil pod jinej kombáč
            ComboBox.minLength=0;
            ComboBox.lastSearch=null;
            
        }

        
    }

    static mouseOver(event) {
        
        if (ComboBox.mouseLock) return;
        if ((event.target instanceof HTMLElement)&&(event.target.matches('.combobox-option:not(.disabled)'))) {
            Listener.activate(event.target);
        }
    }

    static lockMouse(t=25) {
        ComboBox.mouseLock=true;
        clearTimeout(Listener.mouseTimeout);
        Listener.mouseTimeout=setTimeout(()=>{ComboBox.mouseLock=false}, t);
    }

    static activate(element, scrollPlus=false) {
        try {
            let e;
            while (e=ComboBox.inner.querySelector('.combobox-option.active')) {e.classList.remove('active');}
            if (element instanceof HTMLElement) {
                element.classList.add('active');

                if (scrollPlus) {
                    if (element.offsetTop>ComboBox.inner.clientHeight/3) {
                        if (ComboBox.inner.scrollTo) {ComboBox.inner.scrollTo(0, element.offsetTop-ComboBox.inner.clientHeight/3);}
                        ComboBox.inner.scrollTop=element.offsetTop-ComboBox.inner.clientHeight/3;
                    }
                } else {
                    if ((element.offsetTop+element.offsetHeight)>(ComboBox.inner.scrollTop+ComboBox.inner.offsetHeight)) {
                        Listener.lockMouse(250);
                        //element.scrollIntoView(false);
                        ComboBox.Renderer.slowScroll(element.offsetTop+element.offsetHeight-ComboBox.inner.offsetHeight);
                    } else if (element.offsetTop<ComboBox.inner.scrollTop) {
                        Listener.lockMouse(250);
                        //element.scrollIntoView(true);                    
                        ComboBox.Renderer.slowScroll(element.offsetTop);
                    } 
                }
            }
        } catch(e) {};
    }

    static click(event) {

        /// click uvnitř options
        if ((event.target instanceof HTMLElement)&&event.target.matches('.new-combobox-options, .new-combobox-options *')) {
            return;
        }
        
        /// click na další 
        if ((event.target instanceof HTMLElement)&&event.target.matches('.new-combobox .multioption.multi-show-more *')) {
            let multi=event.target;
            while (multi.parentNode&&(!multi.matches('.new-combobox .multi-container'))) {
                multi=multi.parentNode;
            }
            ComboBox.Renderer.hide();
            multi.style.maxHeight='max-content';
            setTimeout(()=>{ComboBox.Renderer.multiOptionsOverflow(multi);}, 50);
            return;
        }
        
        /// click na multi reset
        if ((event.target instanceof HTMLElement)&&event.target.matches('.new-combobox .multi-container .multioption .multioption-reset, .new-combobox .multioption .multioption-reset *')) {
            
            let reset=event.target;
            while (reset.parentNode&&(!reset.matches('.new-combobox .multi-container .multioption'))) {
                reset=reset.parentNode;
            }
            let multi=reset;
            while (multi.parentNode&&(!multi.matches('.new-combobox .multi-container'))) {
                multi=multi.parentNode;
            }
            let combo=multi;
            while (combo.parentNode&&(!combo.matches('.new-combobox'))) {
                combo=combo.parentNode;
            }
            let target=combo.querySelector('input');
            let input=combo.previousElementSibling;
            
            if (input.matches('[readOnly], [disabled], .disabled')) return;
                        
            if (reset&&reset.parentNode&&input&&input.matches('select')&&(input.multiple)) {
                let options=input.querySelectorAll('option');
                for (let i=0, l=options.length; i<l; i++) {
                    if (options[i].value==reset.dataset.value||"") {
                        if (input.dataset.source||input.dataset.sourceAppend||input.dataset.sourceappend) {
                            options[i].parentNode.removeChild(options[i]);
                        } else {
                            options[i].selected=false; 
                            options[i].removeAttribute('selected');
                        }
                    }
                }
                reset.classList.remove('animate-in');
                if (!multi.querySelector('.multioption.multi-show-more')) {
                    reset.classList.add('animate-out');
                    setTimeout(()=>{reset.parentNode.removeChild(reset);}, 750);
                } else {
                    reset.parentNode.removeChild(reset);
                }
            }
            
            if (input) {
                Listener.dispatch(input, 'combo multi change - remove');
            }
            if (target) {
                target.blur();
                target.focus();
                Listener.click({type:'focus', target:target});
            }

            ComboBox.Renderer.multiOptionsOverflow(reset.parentNode);

            ComboBox.Renderer.animatePosition();
            if (ComboBox.shown) {ComboBox.Renderer.show();}
            
            return;
            
        }
        
        /// click na input reset
        if ((event.target instanceof HTMLElement)&&event.target.matches('.new-combobox .combobox-reset, .new-combobox .combobox-reset *')) {

            let reset=event.target;
            while (reset.parentNode&&(!reset.matches('.new-combobox .combobox-reset'))) {
                reset=reset.parentNode;
            }
            let combo=reset;
            while ((!combo.matches('.new-combobox'))&&combo.parentNode) {
                combo=combo.parentNode;
            }

            ComboBox.Renderer.fit(combo);

            let target=combo.querySelector('input');
            let input=combo.previousElementSibling;

            if (input.matches('[readOnly], [disabled], .disabled')) return;

            if (target&&input&&input.matches('input, select')) {
                Listener.blur();
                target.value='';
                input.value='';
                combo.classList.remove('combobox-has-value');
                Listener.dispatch(input, 'combo change - reset');
                target.blur();
                target.focus();
                Listener.click({type:'focus', target:target});
            }

            return;
        }

        /// click na šipečku selectu 
        if ((event.target instanceof HTMLElement)&&event.target.matches('.new-combobox .combobox-arrow, .new-combobox .combobox-arrow *')) {
            let target=event.target.matches('.combobox-arrow')
                    ?event.target.previousElementSibling
                    :event.target.parentNode
                        ?event.target.parentNode.previousElementSibling
                        :null

            if (target) {
                target.focus();
                target.click();
                //ComboBox.Renderer.show();
                return;
            }
        }
            
        /// click kamkoliv, co způsobí blur
        if (ComboBox.target&&(ComboBox.target!=event.target)&&(ComboBox.target!=document.activeElement)) {
            Listener.blur();
        }
        
        /// click na input
        if ((event.target instanceof HTMLElement)&&event.target.matches('.new-combobox input')) {

            let combo=event.target.parentNode;
            while (combo.parentNode) {
                if (combo.matches('.new-combobox')) break;
                combo=combo.parentNode;
            }

            ComboBox.Renderer.fit(combo);

            let input=combo.previousElementSibling;

            if (input.matches('[disabled], .disabled')) {
                event.target.setSelectionRange(0,0);
                event.target.blur();
                return;
            }

            if (input.matches('[readOnly]')) {
                event.target.setSelectionRange(0,0);
                return;
            }

            event.target.setSelectionRange(0,event.target.value.length,"backward");

            if (ComboBox.target!=event.target) {
                
                if (input&&input.matches('input[type=text], select')) {
                    if (combo.matches('.combobox-select')) {
                        let o=input.querySelectorAll('option');
                        ComboBox.originalOptions=[];
                        for(let i=0, l=o.length; i<l; i++) {
                            ComboBox.originalOptions.push({
                                value:o[i].value,
                                display:o[i].innerHTML,
                                short:o[i].dataset.short||'',
                                disabled:o[i].disabled||o[i].matches('.disabled'),
                                sequence:parseInt(o[i].dataset.sequence),
                            })
                        }                
                        if (input.matches('.user-sequence')) {
                            for (let a=0, l=ComboBox.originalOptions.length; a<l; a++) {
                                for (let b=a+1, l=ComboBox.originalOptions.length; b<l; b++) {
                                    if (ComboBox.originalOptions[a].sequence>ComboBox.originalOptions[b].sequence) {
                                        ComboBox.originalOptions.splice(a,0,ComboBox.originalOptions.splice(b,1)[0]);
                                    }
                                }
                            }
                        }
                        ComboBox.options=ComboBox.originalOptions.filter(()=>true);
                    }

                    ComboBox.target=event.target;
                    ComboBox.input=input;
                    ComboBox.combo=combo;
                    ComboBox.multi=combo.querySelector('.multi-container');
                    ComboBox.value=input.multiple?null:input.value||'';
                    ComboBox.display=event.target.value||'';
                    ComboBox.oldDisplay=event.target.value||'';
                    ComboBox.ajax_url=((input.dataset.source||'')+(input.dataset.sourceAppend||input.dataset.sourceappend||''))||'';
                    ComboBox.ajax_param=(input.dataset.keyName||input.dataset.keyname||input.dataset.key||'term');
                    ComboBox.query=(input.dataset.queryAppend||input.dataset.queryappend||input.dataset.query||'');
                    ComboBox.minLength=ComboBox.ajax_url?Math.max((parseInt(input.dataset.minLength||input.dataset.minlength||0)||0),0):0;
                    ComboBox.lastSearch=null;
                    
                }
                
            }

            if (event.type=='click') {
                if ((!ComboBox.minLength)&&ComboBox.ajax_url&&!ComboBox.options.length) {
                    ComboBox.lastSearch='';
                    ComboBox.ajax();
                }
                ComboBox.Renderer.toggle();
            }
            
        }
                        
    }
    
    static arrow(key) {
        if (ComboBox.ajax_pending) return;
        if (!ComboBox.shown) {
            ComboBox.Renderer.show();
            switch(key) {
                case 'arrowup':
                case 'arrowdown':
                case 'up':
                case 'down':
                    return;
            }
        }
        if (!ComboBox.inner) return;
        
        let e;
        let s;
        let a;
        let h=0;
        let r=~['up', 'arrowup','end','pageup'].indexOf(key);
        switch(key) {
            case 'arrowup':
            case 'arrowdown':
            case 'up':
            case 'down':
                if ((a=ComboBox.inner.querySelector('.combobox-option.active'))) {
                    s=a[r?'previousElementSibling':'nextElementSibling'];
                    while (s) {
                        if (s.matches('.combobox-option:not(.disabled)')) {
                            a=s;
                            break;
                        }
                        s=s[r?'previousSibling':'nextSibling'];
                    }
                }
            case 'pageup':
            case 'pagedown':
                a=a||ComboBox.inner.querySelector('.combobox-option.active');
            case 'home':
            case 'end':
                if (!a) {
                    e=ComboBox.inner.querySelectorAll('.combobox-option:not(.disabled)');
                    a=e[r?e.length-1:0];
                }
                if (a&&(~['pageup','pagedown'].indexOf(key))) {
                    s=a[r?'previousElementSibling':'nextElementSibling'];
                    while (s) {
                        h+=s.offsetHeight;
                        if (h>ComboBox.inner.offsetHeight) break;
                        if (s.matches('.combobox-option:not(.disabled)')) {
                            a=s;
                        }
                        s=s[r?'previousSibling':'nextSibling'];
                    }                    
                }
            
        }
        if (a) {
            Listener.activate(a);
/*            if (!(ComboBox.input&&ComboBox.input.matches('select')&&ComboBox.input.multiple)) {
                ComboBox.target.value=a.dataset.short||a.innerText;
                ComboBox.display=ComboBox.target.value;
                event.target.setSelectionRange(0,-1,"backward");
                ComboBox.lastSearch=ComboBox.target.value
                ComboBox.keyPressed=false;
            }*/
        }
        
    }
    
    static keyDown(event) {
        if (event.target==ComboBox.target) {
            //if (!ComboBox.shown) {ComboBox.Renderer.show();}
            let t=ComboBox.target;
            switch (event.key.toLowerCase()) {
                case 'arrowup':
                case 'up':
                case 'arrowdown':
                case 'down':
                case 'pagedown':
                case 'pageup':
                case 'home':
                case 'end':
                    if (event.shiftKey) return;
                    Listener.arrow(event.key.toLowerCase());
                    if (ComboBox.inner) {
                        event.preventDefault();
                        return false;
                    }
                case 'tab':
                case 'enter':
                    if (ComboBox.ajax_pending) {
                        if (event.key.toLowerCase()=='enter') {
                            event.preventDefault();
                            return false;
                        }
                    } else {
                        let e;
                        if (e=document.querySelector('.new-combobox-options .combobox-option.active')) {
                            Listener.blur(e); t.blur(); t.focus();
                            Listener.click({type:'focus', target:t});
                        }
                        if (event.key.toLowerCase()=='enter') {
                            ComboBox.lastSearch=ComboBox.target.value;
                            event.preventDefault();
                            return false;
                        }
                    }
                    break;
                case 'esc':
                case 'escape':

                    Listener.blur();
                    t.blur();
                    t.focus();
                    Listener.click({type:'focus', target:t});
                    ComboBox.lastSearch=ComboBox.target.value;

                    return;
                default:setTimeout(()=>{Listener.keyUp(event);},5);
            }
        }
        
        
    }
    
    static paste(event) {
        ComboBox.lastSearch ??= '';
        setTimeout(()=>{Listener.keyUp(event);}, 25);
    }
    
    static keyUp(event) {
        if (event.target==ComboBox.target) {
            if (!ComboBox.keyPressed) {
                if (ComboBox.target.value!=ComboBox.display) {
                    //ComboBox.target.value=~-event.key.length?'':event.key;
                    ComboBox.keyPressed=true;
                }
            } 

            if (ComboBox.lastSearch!==ComboBox.target.value) {
                if (ComboBox.originalOptions.length) {
                    let search=event.target.value;
                    if (typeof search.normalize === 'function') {
                        search=search.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                    } else { // asi jen IE a to končí...
                        search=search.toLowerCase();
                    }
                    let indexedOptions=ComboBox.originalOptions.map((o, i)=>{
                        if (!ComboBox.keyPressed) return {option:o, index:0};
                        let value=o.display||o.value;
                        if (typeof value.normalize === 'function') {
                            value=value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
                        } else {
                            value=value.toLowerCase();
                        }
                        return {option:o, index:value.indexOf(search)};
                    });

                    ComboBox.options=[
                        ...indexedOptions.filter((io)=>!io.index),
                        ...indexedOptions.filter((io)=>io.index>0),
                    ].map((oi)=>oi.option);

                    if (ComboBox.keyPressed) {ComboBox.Renderer.show();}
                } else if (ComboBox.ajax_url) {
                    ComboBox.ajax();
                    ComboBox.Renderer.show();
                };
            }
            ComboBox.lastSearch=ComboBox.target.value;
        }
    }
    
}